import { useState } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { usePRD3060_R01Store } from "./Store_PRD3060_R01";

export const SearchSection_PRD3060_R01 = () => {
    const { PRD3060_R01Filter, setPRD3060_R01Filter } = usePRD3060_R01Store();
    const { compCdList, brandCdList } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
    const [outputPickerVisible, setOutputPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
        top: 0,
        left: 0,
    });
    const [outputPickerPosition, setOutputPickerPosition] = useState<{ top: number; left: number }>({
        top: 0,
        left: 0,
    });

    return (
        <div className="w-full">
            <SearchSectionForm>
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={PRD3060_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={(v) =>
                        setPRD3060_R01Filter({ ...PRD3060_R01Filter, compCd: v === "all" ? "" : v })
                    }
                />
                <SearchDateRangeForm
                    label="생산일자"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={PRD3060_R01Filter.productDt}
                    setDateRange={(v) => setPRD3060_R01Filter({ ...PRD3060_R01Filter, productDt: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={PRD3060_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setPRD3060_R01Filter({ ...PRD3060_R01Filter, brandCd: v === "all" ? "" : v })
                    }
                />
                <SearchDateSingleForm
                    label="출력일"
                    visible={outputPickerVisible}
                    setVisible={setOutputPickerVisible}
                    value={PRD3060_R01Filter.outputDt}
                    onChange={(v) =>
                        setPRD3060_R01Filter({ ...PRD3060_R01Filter, outputDt: v })
                    }
                    pickerPosition={outputPickerPosition}
                    setPickerPosition={setOutputPickerPosition}
                />
            </SearchSectionForm>
        </div>
    );
};
